export interface OrderData {
  order_service_consecutive: number;
  estimate_consecutive: number;
  code: string;
  quantity: number;
  cant_imports: number;
  cant_disp: number;
  dispatchType: string;
  description: string;
  price_list: number;
  order_observation: string;
}

interface Order {
  id: number;
  order_service_consecutive: number;
  estimate_consecutive: number;
  code: string;
  quantity: number;
  cant_disp: number;
  cant_imports: number;
  unit_cost: number;
  weight: number;
  fromDate?: {
    day: number;
    month: number;
    year: number;
  };
  dateForDelivery: string;
  description?: string;
  dispatchType?: string;
  order_observation?: string;
  price_list?: number;
  importOrders: ImportOrder[]; // Añadir esta propiedad
}
export interface ImportOrder {
  consecutive: string;
  quantity: number;
}

import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AreasService } from "../../master-services/area-services/areas.service";
import swal from "sweetalert2";
import { Console, error } from "console";
import { OrderService } from "../../master-services/order-service/orderservice.service";
import {
  NgbCalendar,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import { catchError } from "rxjs/operators";
import { ModalBasicComponent } from "../../shared/modal-basic/modal-basic.component";

@Component({
  selector: "app-master-OS-Detail",
  templateUrl: "./master-OS-Detail.component.html",
  styleUrls: [
    "./master-OS-Detail.component.css",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MasterOSdetailComponent implements OnInit {
  comentCartera = [
    { key: "Sobrepasa cupo asignado", value: "Sobrepasa cupo asignado" },
    {
      key: "Tercero con cartera vencida",
      value: "Tercero con cartera vencida",
    },
    { key: "Aprobado", value: "Aprobado" },
  ];

  userCustomer: boolean = false;
  orderserviceconsecutive: any;
  customer_name: any;
  orderservices: any;
  orderserviceslogist: any;
  orderservicesdetail: any;
  ordencancelada: any;
  user_order_role: any;
  showOSDetails: boolean = false;
  closeOrderServiceproperty: boolean = false;
  carteraObservations: string = "";
  progressBar_value: number; /// Se setea en 1 porque la logica empieza con 0
  progressBarchanged: number;
  emailcustomer: string = "";
  importQuantity: number;
  warehouseQuantity: number;
  userInput: any[] = [];
  cant_imports: number[] = [];
  cant_disp: number[] = [];
  crossReferenceCode: any[] = [];
  fromDate: NgbDateStruct;
  untilDate: NgbDateStruct;
  today = this.calendar.getToday();
  dateForDelivery: string;
  pidUsdTotal: number[] = [];
  pesoTotal: number[] = [];
  emailImports: string = "";
  emailLogist: string = "";
  emailcartera: string = "";
  emailFactura: string = "";
  comercial_email: string = "";
  orderlogistdispatch: any;
  product_arrived: number = 0;
  importOrdersValues: any[] = [];
  import_order: any;
  importfilteredOrders: any;
  importOrders_detail: any;
  stock_products: any;
  wait_products: any;
  filter_products_logist: any;
  registeredProducts: any;
  arrivedProducts: any;
  remissionProducts: any;
  dispatchProducts: any;
  combinedProducts: any;
  guideNumber: string = "";
  productlogistIds: number[];
  showDispatchButton: boolean = false;
  showDispatchArrivalSection: boolean = false;
  dispatchArrivedDate: NgbDateStruct;
  availableDispatchGroups: any[] = [];
  selectedDispatchGroup: any = null;
  remision_number: string = "";
  user_id: any;

  updatedObservation: string;

  editImportQuantityLogist: any;
  editAlmacenQuantityLogist: any;
  editCruReferenceLogist: any;
  editTotaltQuantityLogist: any;
  editLogistOrder: any;
  isVisibleEdit: boolean = false;
  allStateBasketTrue: boolean = false;
  isRptoMaintenance: any;
  anticipoOrderService: any;
  anticipoOrderComercialCreator: any;
  editingOrigin: number = null;
  updatedOrigin: number = null;

  blindprogres45barTable: boolean = false;

  files = [];
  payments = [];
  totalPayments = 0;
  newPayment = 0;

  userProfile = 0;

  @ViewChild("modalRegisterPayment") modalRegisterPayment: ModalBasicComponent;

  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private orderservice: OrderService,
    private calendar: NgbCalendar
  ) {
    ////Aca obtengo el consecutivo que se pasa  parametro como variableee
    //// Con esto ejecuto index y paso el consecutivo para toda la data
    if (Number(localStorage.getItem("profile")) == 10) {
      this.userCustomer = true;
    }

    this.userProfile = Number(localStorage.getItem("profile"));
    this.orderserviceconsecutive = this.rutaActiva.snapshot.params.id;
    this.index();
  }
  ngOnInit() {}

  index() {
    console.log(
      "Consecutivo pasado como variable",
      this.orderserviceconsecutive
    );

    try {
      this.getUser_OS_permision();
      this.getOrderServiceData_dist();
      this.getOrderserviceData_detail_Dist();
      this.getOrderServiceData_logist_dist();
      this.getImportOrder();
      this.getImportOrder_detail_dist();
      this.getOSFiles();

      this.remision_number = "";
      // Evaluar si la orden está terminada para cerrarla solo si progressBar_value < 100
    } catch (error) {
      console.error("Error en la inicialización:", error);
    }
  }

  getUser_OS_permision() {
    ///Obtengo los datos para permiso de usuario de Order service
    /// Roles de usuarios para gestion de acciones del modulo de ordenes:
    /// 1: Administrador
    /// 2: Cartera
    /// 3: Importaciones
    /// 4: Logistico

    ///Obtengo la id
    this.user_id = localStorage.getItem("userid");
    //La convierto en numero para hacer la consulta a users y tomar orderservice_role
    this.user_id = +this.user_id;

    console.log(
      "Aca id de usuario desde index antes de consultar",
      this.user_id
    );
    this.orderservice
      .getUser_OS_permision(this.user_id)
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.user_order_role = resp.data;
        console.log("Permiso de role", this.user_order_role);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  /// Obtengo los datos de detalle de OorderService discretizando la cot
  getOrderserviceData_detail_Dist() {
    this.orderservice
      .getOrderserviceDetailDist(this.orderserviceconsecutive)
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.orderservicesdetail = resp.data;

        this.orderservicesdetail.forEach((item) => {
          if (Array.isArray(item.orders)) {
            item.orders = [...item.orders].reverse();
          }
        });

        console.log(
          "Data recibida de ordenes_detail:",
          this.orderservicesdetail
        );
        this.cant_imports = [];
        this.cant_disp = [];

        this.orderservicesdetail.forEach((item) => {
          item.orders.forEach((order) => {
            this.cant_imports.push(0); // Inicializa con 0 para cada orden
            this.cant_disp.push(0); // Inicializa con 0 para cada orden
            this.validateQuantity();
          });
        });
        if (this.orderservicesdetail.length > 0) {
          this.emailcustomer =
            this.orderservicesdetail[0].orders[0].customer_email;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  //Obtengo los datos de la tabla order_service
  getOrderServiceData_dist() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getOrderserviceDist(this.orderserviceconsecutive)
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.orderservices = resp.data;
        this.comercial_email =
          this.orderservices[0].orders[0].user.comercial_email;
        console.log("Data recibida de ordenes normalito:", this.orderservices);
        console.log("Email de comercial:", this.comercial_email);

        // Asigno variable de progresso a correspondiente y genero una adicional para ocultar en html
        if (this.orderservices.length > 0) {
          this.progressBar_value =
            this.orderservices[0].orders[0].progressBar_value;
          const estimateValue =
            this.orderservices[0].orders[0].estimate_consecutive;
          this.isRptoMaintenance = estimateValue === 1; // Asigna true si es 1, false en caso contrario
          this.customer_name = this.orderservices[0].orders[0].business_name;
          this.anticipoOrderComercialCreator =
            this.orderservices[0].orders[0].anticipo_orderService;
          this.ordencancelada = this.orderservices[0].orders[0].close_order;
        }
        ////La barra de progreso se maneja solo con el primer array de todos los registros q pueda tener.
        console.log("Barra de progreso", this.progressBar_value);
        console.log("Anticipooooo", this.anticipoOrderComercialCreator);
        console.log(
          "recuperando variable de cotizacion",
          this.isRptoMaintenance
        );
        this.progressBarchanged = this.progressBar_value;

        if (this.orderservices[0].orders[0].anticipo_orderService) {
          this.getOsPayments();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  getImportOrder() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice
      .getImportOrder()
      .then((data) => {
        const resp: any = data;
        console.log(data);

        this.import_order = resp.data;
        console.log("Data recibida de Importorders:", this.import_order);

        ///Filstrado de datos
        this.importfilteredOrders = this.import_order.filter(
          (order: any) => order.product_arrived === 0
        );

        console.log(
          "Data filtrada donde product_arrived es igual a cero, desde importOrders:",
          this.importfilteredOrders
        );
        swal.close();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getOrderServiceData_logist_dist() {
    this.orderservice
      .getOrderserviceLogisDist(this.orderserviceconsecutive)
      .then((data) => {
        const resp: any = data;

        swal.close();
        this.orderserviceslogist = resp.data;
        console.log(
          "Data recibida de ordenes logistica:",
          this.orderserviceslogist
        );

        this.orderserviceslogist.forEach((item) => {
          if (Array.isArray(item.orders)) {
            item.orders = [...item.orders].reverse();
          }
        });

        console.log("Aca estado allStateBasketTrue ", this.allStateBasketTrue);
        this.allStateBasketTrue = this.orderserviceslogist.every((item) =>
          item.orders.every((order) => order.stateBasket === 1)
        );

        console.log("¿Todos los stateBasket son 1?:", this.allStateBasketTrue);
        console.log(
          "Aca estado allStateBasketTrueDESPUESSS ",
          this.allStateBasketTrue
        );
        ///Acaa logica para invocar funcion
        if (this.allStateBasketTrue === true && this.progressBar_value == 45) {
          this.changeStatusLogist();
        } else {
          console.warn(
            "La barra de progreso no es 45 o allStateBasketTrue no es true no se ejecuta nadaaa."
          );
        }

        //const importOrdersValues = [];
        this.orderserviceslogist.forEach((item) => {
          item.orders.forEach((order) => {
            if (order.importOrders && order.importOrders.length > 0) {
              order.importOrders.forEach((importOrder) => {
                this.importOrdersValues.push({
                  ...importOrder,
                  orderDetail_id: order.id,
                });
              });
            }
          });
        });

        console.log(
          "Valores de importOrders en variable:",
          this.importOrdersValues
        );
        this.calculateTotals();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  startStateOS() {
    console.log("Aca cambiare de estados");
    this.showOSDetails = true;
    this.progressBar_value = 30;
    console.log("Aca comentario cartera para act", this.carteraObservations);
    this.orderservice
      .updateOrderserviceStatus(
        this.orderserviceconsecutive,
        this.progressBar_value
      )
      .then((data) => {
        const resp: any = data;
        console.log(data);

        console.log("se ha creado la actualizacion", data);
        this.sendEmailNotifications();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  updatestatusinit() {
    const now = new Date();
    const localISOTime = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    const updateData: any = {
      status: this.progressBar_value,
      approval_date: localISOTime, // Ejemplo, si esta fecha es relevante
    };

    // Incluir carteraObservations solo si progressBar_value es 15 (rechazado)
    if ((this.progressBar_value === 15 || this.progressBar_value === 30) && this.carteraObservations) {
      updateData.carteraObservations = this.carteraObservations;
    }

    if (this.anticipoOrderService) {
      console.log("Acaaa condicion dentro del if");
      console.log("Acaaa data", updateData);

      ///Acaaa agrego los nuevos campos
      updateData.anticipo_orderService = this.anticipoOrderService;
      updateData.fecha_anticipo = localISOTime;

      console.log("Acaaa data Despues", updateData);
    }
    console.warn("Acaaa data Despues Despues", updateData);

    this.orderservice
      .updateOrderserviceStatus2(this.orderserviceconsecutive, updateData)
      .then((data) => {
        console.log(data);
        console.log("Se ha creado la actualización", data);

        // Enviar notificación por correo según el valor de progressBar_value
        if (this.progressBar_value === 30) {
          this.sendEmailNotifications();
        } else if (this.progressBar_value === 15) {
          this.sendEmailReject();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  startStateOS2() {
    console.log("Aca cambiare de estados");
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.showOSDetails = true;
    this.progressBar_value = 30;
    //console.log("Aca comentario cartera para act", this.carteraObservations);
    this.updatestatusinit();
  }

  rejectOrderByFinance() {
    console.log("Aca cambiare de estados con ob servacion de cartera");
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.showOSDetails = true;
    this.progressBar_value = 15;
    console.log(
      "Aca comentario cartera para actualizar",
      this.carteraObservations
    );
    //swal.close();
    this.updatestatusinit();
  }

  formatNumber(value: number): string {
    if (value === null || value === undefined) {
      return "";
    }

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  formatNumber2(value: number): string {
    if (value === null || value === undefined) {
      return "";
    }

    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  }

  totalcantLogist(value1: number, value2: number): number | string {
    try {
      if (isNaN(value1) || isNaN(value2)) {
        throw new Error("Uno o ambos valores no son números");
      }

      if (value1 == null || value2 == null) {
        throw new Error("Uno o ambos valores son nulos o indefinidos");
      }

      return value1 * value2;
    } catch (error) {
      console.error(error.message);
      return "Error";
    }
  }
  calculateTotals() {
    this.pidUsdTotal = [];
    this.pesoTotal = [];

    this.orderserviceslogist.forEach((item, i) => {
      item.orders.forEach((order, j) => {
        const pidTotal = this.totalcantLogist(
          this.getPidUsdUnit(order),
          order.cant_imports
        );
        const pesoTotal = this.totalcantLogist(
          order.weight,
          order.cant_imports
        );

        // Almacenar los resultados en las variables correspondientes
        this.pidUsdTotal[i * item.orders.length + j] = pidTotal as number;
        this.pesoTotal[i * item.orders.length + j] = pesoTotal as number;
      });
    });
  }

  formatDate(isoDate: string): string {
    // Que la cadena sea válida
    if (!isoDate) return "";

    // Dividir la cadena en la fecha y la hora
    const [date, time] = isoDate.split("T");

    // Obtener solo la parte de la hora sin los milisegundos y la 'Z'
    const formattedTime = time.split(".")[0];

    // Devolver la fecha en el formato deseado
    return `${date} ${formattedTime}`;
  }

  validateQuantity() {
    //console.log("Cantidad para importar", this.cant_imports);
    //console.log("Cantidad para almacen", this.cant_disp);
    let allowContinue = true; // Variable para controlar si se permite continuar

    this.orderservicesdetail.forEach((item) => {
      item.orders.forEach((order, index) => {
        // Obtener la suma de cantidadParaImportar y cantidadDisponible
        const suma = this.cant_imports[index] + this.cant_disp[index];
        //console.log("suma", suma);

        // Comprobar si la suma es menor, mayor o igual a quantity
        if (
          suma < 0 ||
          suma == 0 ||
          suma > order.quantity ||
          suma < order.quantity
        ) {
          allowContinue = false; // No permitir continuar si la suma es menor que 0 o mayor que quantity
          // console.log(
          //   `La suma es menor o mayor que la cantidad pedida  ${order.estimate_consecutive}.`
          // );
        } else if (
          this.cant_imports[index] === order.quantity ||
          this.cant_disp[index] === order.quantity
        ) {
          // Permitir continuar si alguna de las cantidades es igual a quantity
          // console.log(
          //   `Se puede continuar porque Cantidad para Importar o Cantidad disponible es igual a la cantidad total para el pedido ${order.estimate_consecutive}.`
          // );
        } else {
          // La suma está entre 0 y quantity, no hacer nada especial
          //console.log(`Ultimo log ${order.estimate_consecutive}.`);
        }
      });
    });

    if (allowContinue) {
      // Devolver las cantidades discretizadas si se permite continuar
      return {
        cant_imports: this.cant_imports.slice(), // Crear una copia para evitar modificaciones externas
        cant_disp: this.cant_disp.slice(), // Crear una copia para evitar modificaciones externas
      };
    } else {
      return null; // Devolver null si no se permite continuar
    }
  }

  handleValidatedData() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    const validatedData = this.validateQuantity();

    if (validatedData) {
      // Si validatedData no es null, significa que se puede continuar
      // console.log(
      //   "Datos validados y permitidos para continuar:",
      //   validatedData
      // );
      // Mapeo de datos para creacion
      const orderData: OrderData[] = this.orderservicesdetail
        .map((item) => {
          return item.orders.map((order, index) => {
            return {
              order_service_consecutive: order.orderservice_consecutive,
              estimate_consecutive: order.estimate_consecutive,
              delivery: Number(order.delivery),
              code: order.code,
              quantity: order.quantity,
              cant_imports: this.cant_imports[index],
              cant_disp: this.cant_disp[index],
              crossReferenceCode: this.crossReferenceCode[index],
              dispatchType: order.dispatchType,
              description: order.description,
              price_list: order.price_list,
              order_observation: order.order_observation,
              unit_cost: order.unit_cost,
              weight: order.weight,
              weight_type: order.weight_type,
              subtotal: order.subtotal,
              total: order.total,
              price_suggest: order.price_suggest,
              stateBasket: 0, /// Agregue este falta en imports Detail
              od_id: order.od_id,
              customer_name: this.customer_name,
              warehouse_description:
                this.orderservices[0].orders[0].warehouse_description,
              petitioner_email: this.comercial_email,
              comercial_name: this.orderservices[0].orders[0].user_name,
            };
          });
        })
        .flat(); // Aplanar el array

      //Aqui invocar servicio para crear el detalle de imp/despacho
      console.log("Aca data para post", orderData);

      this.createOrderLogist(orderData);
      this.createImportOrderStock(orderData);
      this.sendEmailLogistProducts(orderData);
    } else {
      // Si validatedData es null, significa que no se puede continuar
      console.log("No se puede continuar debido a datos inválidos.");
      swal({
        title: "La cantidad de items debe ser correcta",
        type: "error",
      });
      // Puedes mostrar un mensaje de error al usuario o manejar la situación de otra manera.
    }
  }

  createImportOrderStock(orderData) {
    // Filtrar los elementos con cant_disp > 0
    const filteredOrderData = orderData.filter((item) => item.cant_disp > 0);

    // Mapear los elementos filtrados
    const array_import_order_detail = filteredOrderData.map((item) => {
      return {
        orderserviceConsecutive: item.order_service_consecutive,
        estimateConsecutive: item.estimate_consecutive,
        code: item.code,

        PID_unit: item.unit_cost,
        cant_imports: 0,
        quantity_toImport: 0,
        cant_disp: item.cant_disp,
        importOrderConsecutive: 0,
        weight: item.weight,
        total_quantity: item.quantity,
        product_arrived: 0,
        product_remision: 0,
        product_registered: 0,
        cant_registered: 0,
        stock: 1,
        description: item.description,
        crossReferenceCode: item.crossReferenceCode,
        od_id: item.od_id,
        customer_name: this.customer_name,
        warehouse_description:
          this.orderservices[0].orders[0].warehouse_description,
        petitioner_email: item.petitioner_email,
        comercial_name: item.comercial_name,
      };
    });

    console.log(
      "Acaa array nuevo para crear logist",
      array_import_order_detail
    );

    this.orderservice
      .createImportOrderDetail(array_import_order_detail)
      .then((data) => {
        if (data && typeof data === "object" && "success" in data) {
          console.log("Se ha creado el post", data);
          swal({
            title: "Se ha registrado los pedidos de importacion",
            type: "success",
          });
          this.progressBar_value = 45;
          this.updateStatusOS();
          swal.close();
        } else {
          console.log("Error al crear POSTLOGIST discretizadoo:", data);
          // Manejo Adicional de errores
        }
      });
  }
  createOrderLogist(orderData) {
    console.log("Acaaa data pasada para detalle logistico", orderData);
    orderData.forEach((item) => {
      if (item.cant_disp > 0 && item.cant_imports === 0) {
        item.stateBasket = 1;
      }
    });

    console.log("Data modificada:", orderData);

    this.orderservice
      .createOrderLogist(orderData)
      .then((data) => {
        if (data && typeof data === "object" && "success" in data) {
          // Verifica que la respuesta sea exitosa
          console.log("Se ha creado el POSTLOGIST");
        } else {
          console.log("Error al crear POSTLOGIST:", data);
          // Manejo básico del error en consola
        }
      })
      .catch((error) => {
        console.log("Error en la petición:", error);
      });

    ////Aca planeo crear el post para ese array Continuar aca abajoo
  }

  updateStatusOS() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    const now = new Date();
    const localISOTime = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    const updateData: any = {
      status: this.progressBar_value,
    };
    if (this.progressBar_value === 0) {
      updateData.approval_date = localISOTime;
    } else if (this.progressBar_value === 45) {
      updateData.confirmation_date = localISOTime;
    } else if (this.progressBar_value === 65) {
      updateData.date_import_number = localISOTime;
    } else if (this.progressBar_value === 75) {
      updateData.date_reception = localISOTime;
    } else if (
      this.progressBar_value === 100 &&
      this.closeOrderServiceproperty == true
    ) {
      updateData.close_order = 1;
      updateData.date_close_order = localISOTime;
    } else if (this.progressBar_value === 95) {
      updateData.dispatch_date = localISOTime;
    }
    console.log("Data pasada para actualizar el servicio del post", updateData);

    this.orderservice
      .updateOrderserviceStatus2(this.orderserviceconsecutive, updateData)
      .then((data) => {
        console.log(data);
        console.log("se ha creado la actualizacion", data);
        swal({
          title: "Orden de pedido actualizada",
          type: "success",
        });
        swal.close();
        //window.location.reload();
        this.index();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onDateSelectionFrom(date: any) {
    if (this.untilDate) {
      var fromD = new Date(
        this.fromDate.year,
        this.fromDate.month,
        this.fromDate.day
      ); //31 de diciembre de 2015
      var untilD = new Date(
        this.untilDate.year,
        this.untilDate.month,
        this.untilDate.day
      );

      console.log(this.fromDate.day);
      if (fromD > untilD) {
        console.log("es mayor");
        this.untilDate = this.fromDate;
      }
    }
  }

  // confirmDatedelivery(orderserviceslogist: any[]) {
  //   console.log("Orderserviceslogist:", orderserviceslogist); // Log para verificar el array de entrada

  //   let ordersToUpdate: Order[] = [];
  //   orderserviceslogist.forEach((item) => {
  //     item.orders.forEach((order) => {
  //       if (order.fromDate) {
  //         const { year, month, day } = order.fromDate;
  //         const fechaString = `${year}-${month}-${day}`;
  //         order.dateForDelivery = fechaString;
  //         console.log("Order:", order); // Log para verificar cada orden y su fecha de entrega
  //         console.log("Date for delivery:", order.dateForDelivery);
  //       }
  //       ordersToUpdate.push(order);
  //       this.orderlogistdispatch = ordersToUpdate;
  //     });
  //   });
  //   this.updateStatuslogistOS(ordersToUpdate);

  //   //this.progressBar_value = 75;
  // }
  // updateStatuslogistOS(ordersToUpdate: Order[]) {
  //   const now = new Date();
  //   const localISOTime = new Date(
  //     now.getTime() - now.getTimezoneOffset() * 60000
  //   ).toISOString();
  //   // swal({
  //   //   title: "Obteniendo información ...",
  //   //   allowOutsideClick: false,
  //   // });
  //   // swal.showLoading();

  //   // const updateData: any = {
  //   //   status: this.progressBar_value,

  //   //   // Agregar otros datos relevantes solo si están disponibles
  //   //   //approval_date: localISOTime, // Ejemplo, si esta fecha es relevante
  //   //   //confirmation_date: localISOTime, // Ejemplo, si esta fecha es relevante
  //   //   // Otros datos adicionales
  //   // };

  //   // ordersToUpdate.forEach((order) => {
  //   //   updateData.delivery_date = order.dateForDelivery;
  //   // });
  //   // console.log("Data pasada para actualizar el servicio del post", updateData);
  //   console.log("Data pasada traida con las fechas", ordersToUpdate);
  //   this.orderservice
  //     .updateOrderserviceLogist(this.orderserviceconsecutive, ordersToUpdate)
  //     .then((data) => {
  //       console.log(data);
  //       console.log("se ha creado la actualizacion en logistica", data);
  //       swal({
  //         title: "Orden de pedido actualizada en logistica",
  //         type: "success",
  //       });
  //       //this.progressBar_value = 75;
  //       //this.updateStatusOS();

  //       //window.location.reload();
  //       this.sendEmailregister();
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }

  confirmDispach() {
    this.progressBar_value = 100;
    this.updateStatusOS();
  }

  confirmDispatchArrival() {
    if (!this.selectedDispatchGroup && this.selectedDispatchGroup !== 0) {
      swal({
        title: "Debe seleccionar un grupo de despacho",
        type: "error",
      });
      return;
    }
    if (!this.dispatchArrivedDate) {
      swal({
        title: "Debe seleccionar una fecha de llegada",
        type: "error",
      });
      return;
    }

    const { year, month, day } = this.dispatchArrivedDate;
    const dateStr =
      year +
      "-" +
      ("0" + month).slice(-2) +
      "-" +
      ("0" + day).slice(-2);

    const data = {
      orderserviceConsecutive: this.orderserviceconsecutive,
      dispatch_group: this.selectedDispatchGroup,
      dispatch_arrived_date: dateStr,
      emails: `${this.emailcustomer},${this.comercial_email}`,
    };

    swal({
      title: "Procesando...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.orderservice
      .markDispatchArrived(data)
      .then((resp: any) => {
        if (resp && resp.success) {
          swal({
            title: "Llegada confirmada al cliente",
            type: "success",
          });
          this.index();
        } else {
          swal({
            title: "Error al confirmar llegada",
            type: "error",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        swal({
          title: "Error al confirmar llegada",
          type: "error",
        });
      });
  }

  ///Formateo de datos de origen

  priceListMap: { [key: number]: string } = {
    0: "Seleccionar país",
    2: "USA",
    3: "ESPAÑA",
    4: "BELGICA",
    5: "SERVICIO TERCERO",
    6: "REPUESTO NACIONAL",
    7: "SIN",
    8: "USA FPE",
    9: "FLORIDA",
    10: "KANSAS",
    11: "MPE",
  };

  // Función que retorna el nombre correspondiente al número de lista de precios
  getPriceListName(priceList: number): string {
    return this.priceListMap[priceList] || "Desconocido";
  }

  getPidUsdUnit(order: any): number {
    if (order.price_list === 6) {
      return order.price;
    }
    return order.unit_cost;
  }
  ///Formateo de datos de origen

  sendEmailNotifications() {
    //Indico el email de notificacion (cartera y el correo cliente)
    this.emailImports = "importaciones@montacargasmaster.com.co";
    const updateData: any = {
      emails: [this.emailcustomer, this.emailImports, this.comercial_email],
      orderservice: this.orderservices,
      orderserviceDetail: this.orderservicesdetail,
      carteraObservations: this.carteraObservations,
    };
    console.log("Holaaa desde donde mando correo", updateData);
    this.orderservice
      .sendEmailapproval(this.orderserviceconsecutive, updateData)
      .then(() => {
        console.log("se ah enviado el correo");
        //window.location.reload();

        //this.router.navigateByUrl("erp/serviceorder");
        this.index();
      })
      .catch((error) => {
        // Manejar el error en caso de que la promesa sea rechazada
        console.error("Error al enviar notificaciones por correo:", error);
      });
  }

  sendEmailReject() {
    //Indico el email de notificacion (cartera y el correo cliente)
    // console.log(
    //   "Compartiendo email de preaviso de aprobacion de pedido",
    //   this.comercial_email,
    //   this.emailcustomer
    // );

    ///Actualizo la data para pasar el comentario de cartera a comercial y al cliente

    const updateData: any = {
      emails: [this.emailcustomer, this.comercial_email],

      orderservice: this.orderservices,
      orderserviceDetail: this.orderservicesdetail,
      carteraObservations: this.carteraObservations,
    };
    console.log("Holaaa desde donde mando correo", updateData);
    this.orderservice
      .sendEmailReject(this.orderserviceconsecutive, updateData)
      .then(() => {
        console.log("se ah enviado el correo");
        //window.location.reload();

        this.router.navigateByUrl("erp/serviceorder");
      })
      .catch((error) => {
        // Manejar el error en caso de que la promesa sea rechazada
        console.error("Error al enviar notificaciones por correo:", error);
      });
  }

  sendEmailLogistProducts(orderData) {
    //Indico el email de notificacion (cartera y el correo cliente)
    this.emailLogist = "auxlogistica@montacargasmaster.com.co";

    const updateData: any = {
      emails: [this.emailLogist],
      orderservice: this.orderservices,
      orderserviceDetail: this.orderservicesdetail,
      orderData: orderData,
    };
    console.log("Holaaa desde donde mando correo de separacion", updateData);
    this.orderservice
      .sendEmailLogistProducts(this.orderserviceconsecutive, updateData)
      .then(() => {
        console.log("se ah enviado el correo");
        //window.location.reload();
        swal.close();
        //this.index();
        //this.router.navigateByUrl("erp/serviceorder");
      })
      .catch((error) => {
        // Manejar el error en caso de que la promesa sea rechazada
        console.error("Error al enviar notificaciones por correo:", error);
      });
  }

  sendEmailregister(combinedDataWithPrices) {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    //Indico el email de notificacion (cartera y el correo cliente)
    this.emailFactura = "facturacion@montacargasmaster.com.co";

    const updateData: any = {
      emails: [this.emailFactura],

      orderservicelogist: combinedDataWithPrices,
      orderservice: this.orderservices,
    };
    console.log("Data pasada para correo con info para cartera:", updateData);
    // console.log("Holaaa desde donde mando correo", updateData);
    this.orderservice
      .sendEmaildispatch(this.orderserviceconsecutive, updateData)
      .then(() => {
        //this.router.navigateByUrl("erp/serviceorder");
        console.log("Correcto, se envio el correo para solicitar facturacion");
      })
      .catch((error) => {
        // Manejar el error en caso de que la promesa sea rechazada
        console.error("Error al enviar notificaciones por correo:", error);
      });
  }

  validateDispatchQuantity(order: any) {
    if (order.dispatchQuantity > order.quantity) {
      // Mostrar un mensaje de error o deshabilitar el botón de confirmación
      // Por ejemplo:
      console.log(
        "La cantidad a despachar no puede ser mayor que la cantidad disponible."
      );
      // Puedes implementar una lógica adicional aquí para manejar la validación visualmente.
    }
  }

  // updateImportOrderNumbers() {
  //   const NumberOrdertoUpdate = this.orderserviceslogist
  //     .map((item) =>
  //       item.orders.map((order) => ({
  //         order_service_consecutive: order.order_service_consecutive,
  //         code: order.code,
  //         quantity: order.quantity,
  //         importOrderNumber: order.importOrderNumber,
  //       }))
  //     )
  //     .flat(); // Aplanar el array
  //   console.log("Aca datos de numero de pedido", NumberOrdertoUpdate);
  // }

  addImportOrder(order: Order) {
    if (!order.importOrders) {
      order.importOrders = [];
    }
    order.importOrders.push({ consecutive: "", quantity: 0 });
  }

  removeImportOrder(order: Order, index: number) {
    if (order.importOrders) {
      order.importOrders.splice(index, 1);
    }
  }

  validateQuantities(order: any): boolean {
    if (!order.importOrders || order.importOrders.length === 0) {
      return true; // Si no hay pedidos de importación, la validación es considerada exitosa
    }

    // Calcula la cantidad total de importación
    const totalQuantity = order.importOrders.reduce(
      (sum: number, importOrder: any) => {
        // Asegura que quantity sea un número válido
        const quantity = Number(importOrder.quantity) || 0;
        return sum + quantity;
      },
      0
    );

    // Verifica si la cantidad total de importación coincide con la cantidad disponible
    return totalQuantity === order.cant_imports;
  }
  logOrderData(order: Order) {
    console.log(order);
  }

  logAllData() {
    console.log(this.orderserviceslogist);
  }

  // createimportNumber() {
  //   console.log(
  //     "Aca pasando data logist para prueba de cantidaddes",
  //     this.orderserviceslogist
  //   );

  //   let hasErrors = false;

  //   this.orderserviceslogist.forEach((logist) => {
  //     logist.orders.forEach((order) => {
  //       const totalImportQuantity = order.importOrders.reduce(
  //         (sum, importOrder) => sum + importOrder.quantity,
  //         0
  //       );

  //       if (order.cant_imports !== totalImportQuantity) {
  //         console.error(
  //           `Mismatch in quantities for order code: ${order.code}. Order import: ${order.cant_imports}, Import orders total quantity: ${totalImportQuantity}`
  //         );
  //         hasErrors = true;
  //       }
  //     });
  //   });

  //   if (!hasErrors) {
  //     console.log("Data validadaaa ", this.orderserviceslogist);
  //     ///////
  //     let ordersToUpdate: Order[] = [];
  //     this.orderserviceslogist.forEach((item) => {
  //       item.orders.forEach((order) => {
  //         const updatedImportOrders = order.importOrders.map((importOrder) => ({
  //           ...importOrder,
  //           product_arrived: 0,
  //         }));
  //         const updatedOrder = { ...order, importOrders: updatedImportOrders };
  //         ordersToUpdate.push(updatedOrder);
  //       });
  //     });

  //     console.log("Data con el arrivo de productos ", ordersToUpdate);
  //     //////// Aca prueba para post order logist
  //     this.orderserviceslogist.forEach((item) => {
  //       item.orders.forEach((order) => {
  //         if (order.importOrders && order.importOrders.length > 0) {
  //           order.importOrders.forEach((importOrder) => {
  //             this.importOrdersValues.push({
  //               ...importOrder,
  //               orderDetail_id: order.id,
  //             });
  //           });
  //         }
  //       });
  //     });

  //     console.log(
  //       "Valores de importOrders desde selececcionnnnnnnnnnn:",
  //       this.importOrdersValues
  //     );
  //     ///////// Aca termina prueba, aca invoco servicio
  //     // this.orderservice
  //     //   .updateOrderserviceLogistNumber(
  //     //     this.orderserviceconsecutive,
  //     //     ordersToUpdate
  //     //   )
  //     //   .then((data) => {
  //     //     // console.log(data);
  //     //     // console.log("se ha creado la actualizacion en logistica", data);
  //     //     swal({
  //     //       title: "Orden de pedido actualizada en logistica",
  //     //       type: "success",
  //     //     });
  //     //     //this.progressBar_value = 65;
  //     //     //this.updateStatusOS();

  //     //     //window.location.reload();
  //     //   })
  //     //   .catch((error) => {
  //     //     console.log(error);
  //     //   });
  //   } else {
  //     console.error("Some orders have mismatched quantities.");
  //   }
  // }

  onImportOrdersChange(order: any, index: number) {
    // Maneja el cambio en la selección múltiple
    console.log("Import orders changed for order:", order);
    console.log("Cambio en la selección del pedido", order.importOrders[index]);
  }

  // createImportOrderDetail() {
  //   const combinedData = this.orderserviceslogist.flatMap((item) =>
  //     item.orders.flatMap((order) =>
  //       order.importOrders.map((importOrder: any) => {
  //         const stock = order.cant_disp > 0 ? 1 : 0;
  //         return {
  //           estimateConsecutive: order.estimate_consecutive,
  //           code: order.code,
  //           importOrderConsecutive: importOrder.import_order_consecutive,
  //           quantity_toImport: importOrder.quantity,
  //           cant_disp: order.cant_disp,
  //           PID_unit: order.unit_cost,
  //           weight: order.weight,
  //           cant_imports: order.cant_imports,
  //           total_quantity: order.quantity,
  //           product_arrived: 0,
  //           product_registered: 0,
  //           orderserviceConsecutive: this.orderserviceconsecutive,
  //           stock: stock,
  //         };
  //       })
  //     )
  //   );

  //   // Validar todas las órdenes
  //   const allOrdersValid = this.orderserviceslogist.every((item) =>
  //     item.orders.every((order) => this.validateQuantities(order))
  //   );

  //   if (allOrdersValid) {
  //     console.log("Todas las órdenes son válidas");
  //     console.log("Datos combinados:", combinedData);
  //     this.orderservice.createImportOrderDetail(combinedData).then((data) => {
  //       if (data && typeof data === "object" && "success" in data) {
  //         console.log("Se ha creado el post", data);
  //         swal({
  //           title: "Se ha registrado los pedidos de importacion",
  //           type: "success",
  //         });
  //         this.progressBar_value = 65;
  //         this.updateStatusOS();
  //       } else {
  //         console.log("Error al crear POSTLOGIST:", data);
  //         // Manejo Adicional de errores
  //       }
  //     });
  //   } else {
  //     console.log("Algunas órdenes tienen cantidades inválidas");
  //   }
  // }

  createImportOrderDetail() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    const combinedData = this.orderserviceslogist.flatMap((item) =>
      item.orders.flatMap((order) =>
        order.importOrders
          .filter((importOrder: any) => importOrder.import_order_consecutive)
          .map((importOrder: any) => {
            // const stock = order.cant_disp > 0 ? 1 : 0;
            return {
              estimateConsecutive: order.estimate_consecutive,
              code: order.code,
              importOrderConsecutive: importOrder.import_order_consecutive,
              quantity_toImport: importOrder.quantity,
              cant_disp: 0,
              PID_unit: order.unit_cost,
              weight: order.weight,
              cant_imports: order.cant_imports,
              total_quantity: order.quantity,
              product_arrived: 0,
              product_remision: 0,
              product_registered: 0,
              cant_registered: 0,
              produtc_dispatch: 0,
              orderserviceConsecutive: this.orderserviceconsecutive,
              stock: 0,
              description: order.description,
            };
          })
      )
    );
    ///Si la Data combianada filtrada por consecutivo de Importacion es 0 se actualiza el status porque ya quedo en stock
    if (combinedData.length === 0) {
      // swal.close(); // Cerrar el mensaje de carga
      // swal({
      //   title: "No hay datos para procesar",
      //   text: "Los productos deben estar asociados a un número de pedido",
      //   type: "error",
      // });
      this.progressBar_value = 65;
      this.updateStatusOS();
      return; // Salir de la función
    }

    // Validar todas las órdenes
    const allOrdersValid = this.orderserviceslogist.every((item) =>
      item.orders.every((order) => this.validateQuantities(order))
    );

    if (allOrdersValid) {
      console.log("Todas las órdenes son válidas");
      console.log("Datos combinados:", combinedData);
      this.orderservice.createImportOrderDetail(combinedData).then((data) => {
        if (data && typeof data === "object" && "success" in data) {
          console.log("Se ha creado el post", data);
          swal({
            title: "Se ha registrado los pedidos de importacion",
            type: "success",
          });
          this.progressBar_value = 65;
          this.updateStatusOS();
        } else {
          console.log("Error al crear POSTLOGIST:", data);
          // Manejo Adicional de errores
          swal.close();
          swal({
            title: "Los items deben de asociarse a un numero de pedido",
            type: "error",
          });
        }
      });
    } else {
      console.log("Algunas órdenes tienen cantidades inválidas");
      swal.close();
      swal({
        title: "Las cantidades deben ser validas",
        type: "error",
      });
    }
  }
  getImportOrder_detail_dist() {
    this.orderservice
      .getImportOrder_detail_dist(this.orderserviceconsecutive)
      .then((data) => {
        const resp: any = data;

        this.importOrders_detail = data;

        this.importOrders_detail = [...this.importOrders_detail].reverse();

        console.log(
          "Data recibida de ordenes de IMPORTACIONES Detalle:",
          this.importOrders_detail
        );

        /////Filtrando los datos para mostrarlos en la tabla y estados
        this.filter_products_logist = resp.filter(
          (item: any) => item.cant_disp > 0
        );
        this.wait_products = resp.filter(
          (item: any) =>
            item.stock === 0 &&
            item.product_registered === 0 &&
            item.product_dispatch === 0
        );
        console.log("data filtrada WAITTTT", this.wait_products);
        ///Productos en stock
        this.stock_products = resp.filter(
          (item: any) =>
            item.stock === 1 &&
            item.product_registered === 0 &&
            item.cant_disp > 0
        );
        console.log("data filtrada con stock=1", this.stock_products);
        ///Productos Que llegaron
        this.arrivedProducts = this.importOrders_detail.filter(
          (item: any) =>
            item.product_arrived === 1 && item.product_registered === 0
        );

        console.log(
          "Data filtrada con product_arrived=1:",
          this.arrivedProducts
        );
        ///Productos Que se remisionaron
        this.remissionProducts = this.importOrders_detail.filter(
          (item: any) =>
            item.product_remision === 1 && item.product_registered === 0
        );
        console.log(
          "Data filtrada con product_remission=1:",
          this.remissionProducts
        );

        ////Combinar arrays para mostrar en la tabla
        const combinedProducts = [
          ...this.stock_products,
          ...this.arrivedProducts,
        ];
        console.log("Data combinada:", combinedProducts);
        this.combinedProducts = combinedProducts;

        // Filtrar productos que están Facturados
        this.registeredProducts = this.importOrders_detail.filter(
          (item: any) =>
            (item.product_registered === 1 || item.product_remision === 1) &&
            item.product_dispatch == 0
        );
        console.log(
          "Data filtrada con product_registered=1,remisionado y sin despachar",
          this.registeredProducts
        );
        this.dispatchProducts = this.importOrders_detail.filter(
          (item: any) =>
            item.product_registered === 1 && item.product_dispatch === 1
        );
        console.log(
          "Data filtrada con product_dispatch=1:",
          this.dispatchProducts
        );

        ////Validacion si todos los items estan despachados para cerrar la OS
        this.showDispatchButton =
          this.dispatchProducts.length > 0 &&
          this.stock_products.length === 0 &&
          this.arrivedProducts.length === 0 &&
          this.wait_products.length === 0 &&
          this.registeredProducts.length === 0;

        console.log("Mostrar botón de despacho:", this.showDispatchButton);

        const groups = this.importOrders_detail
          .filter((item: any) => item.dispatch_group != null && item.dispatch_group !== undefined)
          .map((item: any) => item.dispatch_group);
        const uniqueGroups = groups.filter((item: any, index: number) => groups.indexOf(item) === index);
        this.availableDispatchGroups = uniqueGroups.sort((a: any, b: any) => a - b);

        console.log("Grupos de despacho disponibles:", this.availableDispatchGroups);

        const hasDispatchedWithoutArrival = this.importOrders_detail.some(
          (item: any) => item.product_dispatch === 1 && item.dispatch_arrived !== 1
        );
        this.showDispatchArrivalSection =
          this.progressBar_value === 95 || hasDispatchedWithoutArrival;

        console.log("Mostrar seccion llegada de despacho:", this.showDispatchArrivalSection);

        const hasPendingItems = this.importOrders_detail.some(
          (item: any) => item.product_registered === 0 || item.product_dispatch === 0
        );

        if (this.progressBar_value < 100 && this.progressBar_value !== 95 && !hasPendingItems) {
          this.finalizeOrderService();
        } else {
          console.log(
            "No se ejecuta finalizeOrderService: barra=" + this.progressBar_value + ", pendientes=" + hasPendingItems
          );
        }
        //this.index();
      })

      .catch((error) => {
        console.log(error);
      });
  }

  registerProduct() {
    let grandTotal = 0;
    // Implementa la lógica para registrar el producto
    console.log("Datos de productos a facturar:", this.combinedProducts);
    // Generar un nuevo array combinando los datos
    const combinedDataWithPrices = this.combinedProducts.map((product) => {
      // Encuentra el item correspondiente en orderserviceslogist
      const orderDetail = this.orderserviceslogist[0].orders.find(
        (order) =>
          order.order_service_consecutive === product.orderserviceConsecutive &&
          order.code === product.code
      );

      let quantityToBill = 0;
      if (product.product_arrived === 0) {
        quantityToBill = product.cant_disp;
      } else {
        quantityToBill = product.quantity_toImport;
      }

      // Suma al gran total
      grandTotal += quantityToBill * (orderDetail ? orderDetail.unit_cost : 0);

      // Si se encuentra el detalle del pedido, combinar los datos
      if (orderDetail) {
        return {
          id: product.id,
          PID_unit: product.PID_unit,
          estimateConsecutive: product.estimateConsecutive,
          quantity_toImport: product.quantity_toImport,
          code: product.code,
          total_quantity: product.total_quantity,
          cant_disp: product.cant_disp,
          stock: product.stock,
          description: product.description,
          importOrderConsecutive: product.importOrderConsecutive,
          quantityToBill: quantityToBill,
          crossReferenceCode: orderDetail.crossReferenceCode,
          // Datos de orderDetail
          unit_cost: orderDetail.unit_cost,
          price_suggest: orderDetail.price_suggest,
          subtotal: orderDetail.subtotal,
          total_facturar_item: orderDetail.price_suggest * quantityToBill,
          weight: orderDetail.weight,
          orderserviceConsecutive: orderDetail.order_service_consecutive,
          observation: orderDetail.order_observation,
        };
      }

      // Si no se encuentra, devolver el producto con datos específicos
      return {
        PID_unit: product.PID_unit,
        estimateConsecutive: product.estimateConsecutive,
        quantity_toImport: product.quantity_toImport,
        code: product.code,
        total_quantity: product.total_quantity,
        cant_disp: product.cant_disp,
        stock: product.stock,
        importOrderConsecutive: product.importOrderConsecutive,
        // Datos calculados
        total_PARA_facturar: 0,
      };
    });

    console.log("Combined Data with Prices:", combinedDataWithPrices);
    console.log("Grand Total:", grandTotal);
    const productIds = combinedDataWithPrices.map((item) => item.id);

    console.log("Product IDs:", productIds);
    this.sendEmailregister(combinedDataWithPrices);
    this.updateregisterProduct(productIds);
  }

  updateregisterProduct(productIds: number[]) {
    ///Formateo de fecha para pasarla en actualizacion.
    const now = new Date();
    const localISOTime = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    const updateData = {
      id: productIds,
      product_registered: 1,
      date_register: localISOTime,
    };
    console.log("Aca pasando Ids para actualizar", updateData);
    this.orderservice.updateregisterProduct(updateData).then((data) => {
      if (data && typeof data === "object" && "success" in data) {
        console.log("Se ha creado la actualizacion de imports Detail", data);
        swal({
          title: "Se ha cambiado ah facturado",
          type: "success",
        });
        swal.close();
        this.index();
      } else {
        console.log("Error al crear POSTLOGIST:", data);
        // Manejo Adicional de errores
      }
    });
  }

  dispatchItems() {
    ///Validacion de que exista el numero de pedido

    if (!this.guideNumber) {
      console.log("Número de guía no proporcionado");
      swal({
        title: "Número de guía requerido",
        type: "error",
      });
      return;
    }
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    ///Formateo de fecha para pasarla en actualizacion.
    const now = new Date();
    const localISOTime = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    //Agregar el número de guía a cada producto antes de despachar

    const productIds = this.registeredProducts.map((item) => item.id);
    const updateData = {
      id: productIds,
      product_dispatch: 1,
      dispatch_observation: this.guideNumber,
      date_dispatch: localISOTime,
    };

    console.log("Datos para despachar ids:", updateData);

    // Lógica para despachar items, por ejemplo, enviar los datos al backend
    this.orderservice.updateregisterProduct(updateData).then((data) => {
      if (data && typeof data === "object" && "success" in data) {
        console.log("Se ha creado la actualización de imports Detail", data);
        swal({
          title: "Se ha cambiado a facturado",
          type: "success",
        });
        console.log("Invocando email");
        this.sendEmailDispatchItems();
        this.progressBar_value = 95;
        this.updateStatusOS();

        ////Aca correo electronico-----
      } else {
        console.log("Error al crear POSTLOGIST:", data);
        // Manejo adicional de errores
      }
    });
  }

  sendEmailDispatchItems() {
    console.log(
      "Acaaa data que se pasa para despacho",
      this.registeredProducts
    );

    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    //Indico el email de notificacion (cartera y el correo cliente)

    const updateData: any = {
      emails: [this.emailcustomer, this.comercial_email],

      dispatchData: this.registeredProducts,
      guideNumber: this.guideNumber,
    };
    console.log("Data pasada para correo simultaneo:", updateData);
    console.log("Holaaa desde donde mando correo", updateData);
    this.orderservice
      .sendEmaildispatchItemsClient(this.orderserviceconsecutive, updateData)
      .then(() => {
        // this.index();
        console.log("Correcto, se envio el correo para De despacho de items");
      })
      .catch((error) => {
        // Manejar el error en caso de que la promesa sea rechazada
        console.error("Error al enviar notificaciones por correo:", error);
      });
  }

  finalizeDispatchProcess() {
    this.progressBar_value = 100;
    this.updateStatusOS();
  }

  finalizeOrderService() {
    try {
      if (this.showDispatchButton === true) {
        this.progressBar_value = 100;
        this.updateStatusOS();
        console.log("Orden de servicio actualizada AUTOMATICOOOOOO.");
      } else {
        console.log(
          "No se puede finalizar la orden de servicio: showDispatchButton no es true."
        );
      }
    } catch (error) {
      console.error("Error al actualizar la orden de servicio:", error);
    }
  }

  finalizeOrderService2() {
    try {
      if (
        this.showDispatchButton === true ||
        this.orderservices[0].orders[0].with_maintenance_form === 1
      ) {
        this.progressBar_value = 100;
        this.updateStatusOS();
        console.log("Finalizando orden de sevicio.");
      } else {
        console.log(
          "No se puede finalizar la orden de servicio: showDispatchButton no es true."
        );
      }
    } catch (error) {
      console.error("Error al actualizar la orden de servicio:", error);
    }
  }

  remisionProduct() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    const combinedDataWithPrices = this.combinedProducts
      .filter((product) => product.product_remision === 0) // Filtrar productos con product_remision igual a 0
      .map((product) => {
        // Encuentra el item correspondiente en orderserviceslogist
        const orderDetail = this.orderserviceslogist[0].orders.find(
          (order) =>
            order.order_service_consecutive ===
              product.orderserviceConsecutive && order.code === product.code
        );

        let quantityToBill = 0;
        if (product.product_arrived === 0) {
          quantityToBill = product.cant_disp;
        } else {
          quantityToBill = product.quantity_toImport;
        }

        // Si se encuentra el detalle del pedido, combinar los datos
        if (orderDetail) {
          return {
            id: product.id,
            PID_unit: product.PID_unit,
            estimateConsecutive: product.estimateConsecutive,
            quantity_toImport: product.quantity_toImport,
            code: product.code,
            total_quantity: product.total_quantity,
            cant_disp: product.cant_disp,
            stock: product.stock,
            importOrderConsecutive: product.importOrderConsecutive,
            quantityToBill: quantityToBill,
            // Datos de orderDetail
            unit_cost: orderDetail.unit_cost,
            price_suggest: orderDetail.price_suggest,
            subtotal: orderDetail.subtotal,
            total_facturar_item: orderDetail.price_suggest * quantityToBill,
            weight: orderDetail.weight,
            orderserviceConsecutive: orderDetail.order_service_consecutive,
          };
        }

        // Si no se encuentra, devolver el producto con datos específicos
        return {
          PID_unit: product.PID_unit,
          estimateConsecutive: product.estimateConsecutive,
          quantity_toImport: product.quantity_toImport,
          code: product.code,
          total_quantity: product.total_quantity,
          cant_disp: product.cant_disp,
          stock: product.stock,
          importOrderConsecutive: product.importOrderConsecutive,
          // Datos calculados
          total_PARA_facturar: 0,
        };
      });

    console.log("Combined Data with Prices:", combinedDataWithPrices);

    const productIds = combinedDataWithPrices.map((item) => item.id);
    console.log("Aca ids... ", productIds);

    if (productIds.length > 0) {
      this.updateRemisionProduct(productIds);
    } else {
      console.log("No products to update. No remision was made.");
      swal({
        title: "No es posible, los productos estan es pendiente de factura",
        type: "error",
      });
    }
  }

  updateRemisionProduct(productIds: number[]) {
    ///Formateo de fecha para pasarla en actualizacion.
    const now = new Date();
    const localISOTime = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    const updateData = {
      id: productIds,
      product_remision: 1,
      date_remision: localISOTime,
      remision_number: this.remision_number,
    };
    console.log("Aca pasando Ids para actualizar", updateData);
    this.orderservice.updateregisterProduct(updateData).then((data) => {
      if (data && typeof data === "object" && "success" in data) {
        console.log("Se ha creado la actualizacion de imports Detail", data);
        swal({
          title: "Se ha cambiado ah facturado",
          type: "success",
        });
        swal.close();
        this.index();
      } else {
        console.log("Error al crear POSTLOGIST:", data);
        // Manejo Adicional de errores
      }
    });
  }
  formatToThreeDecimals(value: number): string {
    if (value === undefined || value === null || isNaN(value)) {
      // Retorna un valor por defecto si el valor no es válido
      return "0.00";
    }

    // Convierte el valor a número
    const numberValue = Number(value);

    // Formatea el número con 2 cifras decimales y separadores de miles
    const formattedValue = numberValue.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return formattedValue;
  }

  toggleEdit(index: number) {
    this.orderservicesdetail[index].isEditing = true;
  }

  // Función para guardar la observación y desactivar el modo de edición
  saveObservation(index: number) {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservicesdetail[index].isEditing = false;
    this.updatedObservation =
      this.orderservicesdetail[index].orders[0].order_observation;
    console.log(
      "Nueva observación guardada en variable para actualizar:",
      this.updatedObservation,
      this.orderserviceconsecutive
    );
    const dataDetail = { observation: this.updatedObservation };

    this.orderservice
      .updateObservationDetail(this.orderserviceconsecutive, dataDetail)
      .then((data) => {
        if (data && typeof data === "object" && "success" in data) {
          console.log(
            "Se ha creado la actualizacion de imports Detail con observacion",
            data
          );
          swal({
            title: "Se ha cambiado La observacion",
            type: "success",
          });
          swal.close();
        } else {
          console.log("Error al crear POSTLOGIST:", data);
          // Manejo Adicional de errores
        }
      });
  }

  openEditOrderLogist(order) {
    this.editLogistOrder = order; ///ACAA almanceo el item en una variable para el put de abajo.
    console.log(
      "Acaaa orden a editar desde variable asignada",
      this.editLogistOrder
    );
    this.editTotaltQuantityLogist = order.quantity;
    this.editImportQuantityLogist = order.cant_imports;
    this.editAlmacenQuantityLogist = order.cant_disp;
    this.editCruReferenceLogist = order.crossReferenceCode;
    this.isVisibleEdit = true;
    console.log("Acaaa orden a Almacen", this.editAlmacenQuantityLogist);
    console.log("Acaaa orden a Importar", this.editImportQuantityLogist);
  }

  closeModalEdit() {
    this.isVisibleEdit = false;
  }

  toggleChangeOrigin(index: number) {
    this.editingOrigin = index;
  }

  changeOrigin(product, newOrigin) {
    const body = {
      price_list: newOrigin,
    };

    swal({
      title: "modificando origen ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.orderservice
      .updateOrderServiceDetailsOrigin(product.od_id, body)
      .then((data) => {
        swal({
          title: "Se ha cambiado La cantidad",
          type: "success",
        });
        this.toggleChangeOrigin(null);
        this.index();
        swal.close();
        // console.log(this.updatedOrigin);
        // console.log(product);
      });
  }

  getPriceListKeys(map: { [key: number]: string }): number[] {
    return Object.keys(map).map(Number);
  }

  sendEditOrderLogis() {
    const total = this.editTotaltQuantityLogist;
    const importQuantity = this.editImportQuantityLogist;
    const almacenQuantity = this.editAlmacenQuantityLogist;
    console.log("Almacen", almacenQuantity);
    console.log("Importar", importQuantity);
    console.log("Total", total);

    if (importQuantity < 0 || almacenQuantity < 0) {
      console.error(
        "Error: Las cantidades de importar y almacenar no pueden ser negativas."
      );
      alert(
        "Las cantidades de importar y almacenar deben ser valores positivos."
      );
      return;
    }

    if (importQuantity + almacenQuantity !== total) {
      console.error(
        "Error: La suma de Importar y Almacén debe coincidir con el Total."
      );
      alert(
        "La suma de las cantidades a importar y almacenar debe ser igual a la cantidad total."
      );
      return;
    }

    console.warn(
      "Validación exitosa: Las cantidades están correctas. Enviando la data."
    );
    /// Aca empezando a asignar variables que debo actualizar y pasar para editar
    const idOrderLogistItem = this.editLogistOrder.id;
    const odId = this.editLogistOrder.od_id;
    console.log("Acaaa id a pasar", idOrderLogistItem);
    console.log("Acaaa id de logistica a pasar", odId);
    const postdata = {
      //data: this.editLogistOrder,
      cant_disp: almacenQuantity,
      cant_imports: importQuantity,
      crossReferenceCode: this.editCruReferenceLogist,
      estimateConsecutive: this.editLogistOrder.estimate_consecutive,
      orderserviceConsecutive: this.orderserviceconsecutive,
      importOrderConsecutive: 0,
      code: this.editLogistOrder.code,
      description: this.editLogistOrder.description,
      PID_unit: this.editLogistOrder.unit_cost,
      quantity_toImport: 0,
      total_toImport: 0,
      weight: this.editLogistOrder.weight,
      total_quantity: total,
      product_arrived: 0,
      product_remision: 0,
      product_registered: 0,
      product_dispatch: 0,
      stock: 1,
      od_id: odId,
      cant_registered: 0,
      // ...(almacenQuantity === total ? { stateBasket: 1 } : {})
      stateBasket: 1,
    };

    console.log(postdata);
    this.isVisibleEdit = false;
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.orderservice
      .updateCantsOrderLogist(
        idOrderLogistItem,
        postdata,
        this.orderserviceconsecutive,
        odId
      )
      .then((data) => {
        if (data && typeof data === "object" && "success" in data) {
          console.log(
            "Se ha creado la actualizacion de imports Detail con observacion",
            data
          );

          swal({
            title: "Se ha cambiado La cantidad",
            type: "success",
          });

          this.index();
          swal.close();

          // this.getOrderServiceData_logist_dist();
        } else {
          console.log("Error al crear POSTLOGIST:", data);
          // Manejo Adicional de errores
        }
      });
  }

  traslateProduct() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    console.log("Acaaa traslado");
    console.log("Datos de productos a facturar:", this.combinedProducts);
    const productIds = this.combinedProducts.map((item) => item.id);
    console.log("Aca items recuperados", productIds);
    const now = new Date();
    const localISOTime = new Date(
      now.getTime() - now.getTimezoneOffset() * 60000
    ).toISOString();
    const updateData = {
      id: productIds,
      product_registered: 1,
      product_remision: 1,
      date_register: localISOTime,
      date_remision: localISOTime,
      remision_number: this.remision_number,
    };
    console.log("Aca pasando Ids para actualizar", updateData);
    this.orderservice.updateregisterProduct(updateData).then((data) => {
      if (data && typeof data === "object" && "success" in data) {
        console.log("Se ha creado la actualizacion de imports Detail", data);
        swal({
          title: "Se ha cambiado ah facturado",
          type: "success",
        });
        swal.close();
        this.index();
      } else {
        console.log("Error al crear POSTLOGIST:", data);
        // Manejo Adicional de errores
      }
    });
  }

  changeStatusLogist() {
    console.warn("Acaaa cambiare el estado de la os");
    /////Acaaa cambiare el estado de la os cuando se seleccione desde canasta
    try {
      if (this.allStateBasketTrue === true && this.progressBar_value === 45) {
        this.progressBar_value = 65;
        this.updateStatusOS();
        console.log("Orden de servicio actualizada AUTOMATICOOOOOO.");
      } else {
        console.log(
          "No se puede actualizar la orden de servicio : allStateBasketTrue no es true."
        );
      }
    } catch (error) {
      console.error("Error al actualizar la orden de servicio:", error);
    }
  }

  closeOrderService() {
    if (
      window.confirm(
        "¿Estás seguro de cerrar la orden de pedido? Esta acción no se puede deshacer."
      )
    ) {
      try {
        this.progressBar_value = 100;
        this.closeOrderServiceproperty = true;
        this.updateStatusOS();
        console.log("Orden de servicio actualizada AUTOMATICOOOOOO.");
      } catch (error) {
        console.error("Error al actualizar la orden de servicio:", error);
      }
    } else {
      console.log("Cancelado por el usuario");
    }
  }

  getOSFiles() {
    this.orderservice
      .getOrderServiceFiles(this.orderserviceconsecutive)
      .subscribe((resp) => {
        this.files = resp.data.map((data) => ({
          ...data,
          name: data.url.split("/").pop(),
        }));
      });
  }

  getOsPayments() {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.orderservice.getPayments(this.orderserviceconsecutive).subscribe({
      next: (resp) => {
        this.payments = resp.data;
        this.totalPayments = this.payments.reduce(
          (result, payment) => result + Number(payment.amount),
          0
        );
        swal.close();
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  togglePaymentForm() {
    if (this.modalRegisterPayment.visible) {
      this.modalRegisterPayment.hide();
      return;
    }

    this.newPayment = 0;
    this.modalRegisterPayment.show();
  }

  registerPayment() {
    swal({
      title: "registrando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    if (!this.newPayment || this.newPayment < 1) {
      swal({
        title: "El valor del pago debe ser mayor a 0",
        type: "error",
      });
      return;
    }

    const paymentBody = {
      os_consecutive: this.orderserviceconsecutive,
      amount: this.newPayment,
    };

    this.orderservice.createPayments(paymentBody).subscribe({
      next: (resp) => {
        this.index();
        this.togglePaymentForm();
        swal.close();
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  roundNumber(value: number) {
    return Math.floor(value);
  }

  ////
}



// WEBPACK FOOTER //
// ./src/app/master/master-OS-Detail/master-OS-Detail.component.ts